 
 
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute';

const posRoutes: RouteObject[] = [
  {
    path: 'POS/*',
    children: [
      { path: 'install', lazy: lazyRoute(() => import('@pages/POS/POSInstallPage')) },

      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/POS/PosHome/PosHome')) },

      { path: 'PosSettings', lazy: lazyRoute(() => import('../../pages/POS/PosSetting/Pos/Index')) },

      // { path: 'Sessions', lazy: lazyRoute(() => import('../../pages/POS/Sessions/Index')) },
      { path: 'Sessions', lazy: lazyRoute(() => import('../../pages/POS/Sessions/Index2')) },

      {
        path: 'Sessions/SessionDetiles/:sessionId',
        // lazy: lazyRoute(() => import('../../pages/POS/Sessions/SessionDetiles'))
        lazy: lazyRoute(() => import('../../pages/POS/Sessions/Detiles/SessionDetails'))
      },

      {
        path: 'PosSettings/:posId/PosDetails',
        lazy: lazyRoute(() => import('../../pages/POS/PosSetting/PosDetails/PosDetails'))
      },

      { path: 'PosCard', lazy: lazyRoute(() => import('../../pages/POS/PosCard/PosCard')) },

      // POS
      // { path: ':sessionId/PointOfSale', lazy: lazyRoute(() => import('../../pages/POS/PointOfSale/PointOfSale')) },

      { path: 'Returns', lazy: lazyRoute(() => import('../../pages/POS/Returns/Returns')) },
      
      // Scale / Vouchers
      { path: 'Scale', lazy: lazyRoute(() => import('../../pages/POS/PosScale/PosScaleProfilesManagement')) },
      
      // { path: 'Vouchers', lazy: lazyRoute(() => import('../../pages/POS/Vouchers/Index')) },
      // { path: 'Vouchers/AddUpdateVouchers', lazy: lazyRoute(() => import('../../pages/POS/Vouchers/VoucherForm')) },
      // { path: 'Vouchers/:voucherId/AddUpdateVouchers', lazy: lazyRoute(() => import('../../pages/POS/Vouchers/VoucherForm')) },
      
      
      // Sales Orders POS
      { path: 'SalesOrdersPos', lazy: lazyRoute(() => import('../../pages/POS/SellOrder/Index')) },
      { path: 'SalesOrdersPos/:id/View', lazy: lazyRoute(() => import('../../pages/POS/SellOrder/View')) },

      
      // Returns POS
      
      { path: 'PosReturns', lazy: lazyRoute(() => import('../../pages/POS/PosReturns/Index')) },
      
      //Settlement Types
      { path: 'SettlementTypes', lazy: lazyRoute(() => import('../../pages/POS/PosSettlement/SettlementTypes/Index')) },
      { path: 'SessionSettlement', lazy: lazyRoute(() => import('../../pages/POS/PosSettlement/SessionSettlement/Index')) },
      
      { path: 'SettlementPolicy', lazy: lazyRoute(() => import('../../pages/POS/SettlementPolicy/Index')) },
      { path: 'SettlementPolicy/AddSettlementPolicy', lazy: lazyRoute(() => import('../../pages/POS/SettlementPolicy/SettlementPolicyForm')) },
 
      ]
  }
];

export default posRoutes;
